document.addEventListener("DOMContentLoaded", function () {
    const form = document.getElementById("svs-form");
    const message = document.getElementById("formMessage");
    const results = document.getElementById("results");
    const loader = document.getElementById("loader");
    const resultsTable = document.getElementById("resultsTable");
    const submitBtn = form.querySelector(".btn-submit");

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      message.textContent = "";
      results.style.display = "none";
      loader.style.display = "block";
      submitBtn.disabled = true;
      submitBtn.style.opacity = 0.6;
      submitBtn.style.cursor = "not-allowed";

      const firstName = document.getElementById("firstName").value.trim();
      const lastName = document.getElementById("lastName").value.trim();
      const zip = document.getElementById("zipCode").value.trim();
      const month = document.getElementById("dobMonth").value.padStart(2, '0');
      const day = document.getElementById("dobDay").value.padStart(2, '0');
      const year = document.getElementById("dobYear").value;

      if (!firstName || !lastName || !zip.match(/^\d{5}$/) || !month || !day || !year) {
        message.textContent = "Please fill out all fields correctly.";
        loader.style.display = "none";
        submitBtn.disabled = false;
        submitBtn.style.opacity = 1;
        submitBtn.style.cursor = "pointer";
        return;
      }

      const dobInput = `${month}-${day}-${year}`;
      const apiParam = `SVSVISION*${firstName}*${lastName}*${dobInput}*${zip}`;
      const apiUrl = `https://7g8fcsjlq9.execute-api.us-west-2.amazonaws.com/NEWEST?lastname=${encodeURIComponent(apiParam)}`;

      fetch(apiUrl)
        .then(res => res.json())
        .then(data => {
          loader.style.display = "none";
          submitBtn.disabled = false;
          submitBtn.style.opacity = 1;
          submitBtn.style.cursor = "pointer";

          if (!data || data.result?.startsWith("Error") || data.membershipID === "0") {
            message.textContent = "Unable to locate your vision benefits. Please check your info and try again.";
            return;
          }

          form.style.display = "none"; // Hide form on success

  document.getElementById("formHeader").innerHTML = `
    <h2 style="margin: 1rem; font-size: 2.5rem;">Your SVS Vision Care Benefits</h2>
  `;

          const fullName = `${data.firstName} ${data.lastName}`;
          const today = new Date().toLocaleDateString("en-US");
          //const summaryHtml = getSummaryHtmlByGroup(data.groupID);
          const normalizedGroupID = parseInt(String(data.groupID).match(/\d+/)?.[0] || "", 10);
          const summaryHtml = getSummaryHtmlByGroup(normalizedGroupID, data.groupName);
          const memberInfoHtml = `
            <table style="width: 100%; text-align: center; font-size: 11px; border-collapse: collapse;">
              <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
                <td colspan="5" style="padding: 5px;">Member Information</td>
              </tr>
              <tr><td colspan="5" style="padding: 5px;">${fullName}</td></tr>
              <tr>
                <td style="text-align: right; padding: 5px;">MemberID: ${data.membershipID}</td>
                <td colspan="2" style="text-align: right; padding: 5px;">Exam: ${data.eligibleExam ? "Available" : "Not Available"}</td>
                <td colspan="2" style="text-align: right; padding: 5px;">Valid as of Date: ${today}</td>
              </tr>
              <tr>
                <td style="text-align: right; padding: 5px;">Group ID: ${data.groupID}</td>
                <td colspan="2" style="text-align: right; padding: 5px;">Material: ${(data.eligibleLenses || data.eligibleFrame || data.eligibleContact) ? "Available" : "Not Available"}</td>
                <td colspan="2" style="text-align: right; padding: 5px;">Group Name: ${data.groupName ?? "N/A"}</td>
              </tr>
            </table><br>`;
          
          resultsTable.innerHTML = memberInfoHtml + summaryHtml;
          results.style.display = "block";
        })
        .catch(() => {
          loader.style.display = "none";
          message.textContent = "Error communicating with insurance provider.";
          submitBtn.disabled = false;
          submitBtn.style.opacity = 1;
          submitBtn.style.cursor = "pointer";
        });
    });
  });
  
  function getSummaryHtmlByGroup(groupID, groupName) {
    switch (groupID) {
      case 20045:
        return `
          <table style="width: 100%; font-size: 11px; border-collapse: collapse; border: 1px solid #ccc;">
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td colspan="3" style="padding: 5px; text-align: center;">Summary of Benefits</td>
            </tr>
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td style="padding: 5px;"></td>
              <td style="padding: 5px;">In Network</td>
              <td style="padding: 5px;">Out of Network</td>
            </tr>

            <!-- Exams -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Exams: Every Calendar Year</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Routine Eye Exam</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Contact Lens Fitting</td>
              <td style="padding: 5px;">30% off Usual &amp; Customary</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Frames -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Frames: Every Calendar Year</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Frames</td>
              <td style="padding: 5px;">$200 Allowance<br>20% Off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Lenses -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lenses: Every Calendar Year</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Single Vision (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Bifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Trifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard Progressive (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Contact Lenses -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Contact Lenses: Every Calendar Year</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Elective (In Lieu of Glasses)</td>
              <td style="padding: 5px;">$200 Allowance<br>20% Off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Medical (Authorization Required)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">Fully Covered</td>
            </tr>

            <!-- Lens Options -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">All Other Lens Options (applicable to Base Lens only)</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Advanced Lens Designs</td>
              <td style="padding: 5px;">20% Off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Other Materials (Poly, High Index, Trivex)</td>
              <td style="padding: 5px;">20% Off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Solid Tints</td>
              <td style="padding: 5px;">20% Off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Gradient Tints</td>
              <td style="padding: 5px;">20% Off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard AR Coating</td>
              <td style="padding: 5px;">20% Off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Premium AR Coating</td>
              <td style="padding: 5px;">20% Off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Transition</td>
              <td style="padding: 5px;">20% Off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Polarized</td>
              <td style="padding: 5px;">20% Off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Fielmann Lens Package -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Fielmann Lens Package</td>
            </tr>
            <tr>
              <td colspan="3" style="text-align: left; padding: 5px; line-height: 1.35;">
                <strong>At Shopko Optical:</strong> SV SmartLife Individual or Standard SV; Progressive SmartLife Individual.<br>
                Materials available: Plastic, Polycarbonate or Hi Index; anti-reflective coating: DuraVision Platinum.<br>
                In addition SmartLife Young for children under 18 only.<br><br>

                <strong>At SVS Vision:</strong> SV EyeDef TruView 2.0 or Standard SV; Progressive EyeDef Intellilens 2.0.<br>
                Materials available: Plastic, Polycarbonate or Hi Index; anti-reflective coating: Reveal.<br><br>

                <strong>NO OTHER LENS OPTIONS (add-ons) ARE ALLOWED.</strong>
              </td>
            </tr>
          </table><br>`;
      case 8700:
        return `
          <table style="width: 100%; font-size: 11px; border-collapse: collapse; border: 1px solid #ccc;">
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td colspan="3" style="padding: 5px; text-align: center;">Summary of Benefits</td>
            </tr>
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td style="padding: 5px;"></td><td style="padding: 5px;">In Network</td><td style="padding: 5px;">Out of Network</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);"><td colspan="3" style="text-align: left; padding: 5px;">Exams: Every 12 months</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Routine Eye Exam</td><td style="padding: 5px;">Fully Covered</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Contact Lens Fitting</td><td style="padding: 5px;">$40 Allowance</td><td style="padding: 5px;">No Coverage</td></tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);"><td colspan="3" style="text-align: left; padding: 5px;">Frames: Every 12 months</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Frames</td><td style="padding: 5px;">Standard: Fully Covered<br>Designer: $40 Allowance,<br>20% off Overage</td><td style="padding: 5px;">$13 Allowance</td></tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);"><td colspan="3" style="text-align: left; padding: 5px;">Lenses: Every 12 months</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Single Vision (Glass, Plastic)</td><td style="padding: 5px;">Fully Covered</td><td style="padding: 5px;">$13 Allowance</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Bifocal (Glass, Plastic)</td><td style="padding: 5px;">Fully Covered</td><td style="padding: 5px;">$13 Allowance</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Trifocal (Glass, Plastic)</td><td style="padding: 5px;">Fully Covered</td><td style="padding: 5px;">$13 Allowance</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Standard Progressive (Glass, Plastic)</td><td style="padding: 5px;">Fully Covered</td><td style="padding: 5px;">No Coverage</td></tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);"><td colspan="3" style="text-align: left; padding: 5px;">Contact Lenses: Every 12 months</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Elective (In Lieu of Glasses)</td><td style="padding: 5px;">$75 Allowance</td><td style="padding: 5px;">$37 Allowance</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Medical (Authorization Required)</td><td style="padding: 5px;">$350 Allowance</td><td style="padding: 5px;">$52.50 Allowance</td></tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);"><td colspan="3" style="text-align: left; padding: 5px;">Lens Options</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Advanced Lens Designs</td><td style="padding: 5px;">20% off Overage</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Other Materials (Poly, High Index, Trivex)</td><td style="padding: 5px;">20% off Overage</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Solid Tints</td><td style="padding: 5px;">Fully Covered</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Gradient Tints</td><td style="padding: 5px;">20% off Overage</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Standard AR Coating</td><td style="padding: 5px;">20% off Overage</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Premium AR Coating</td><td style="padding: 5px;">20% off Overage</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Transition</td><td style="padding: 5px;">Standard: Fully Covered<br>Premium: 20% off Overage</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Polarized</td><td style="padding: 5px;">20% off Overage</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">All Other Options Not Listed</td><td style="padding: 5px;">
              Scratch resistance for age 12 and under, Fully Covered;<br>
              Lenses < 65 mm in diameter, Fully Covered;<br>
              2 yr limited warranty, Fully Covered;<br>
              all else, 20% off Overage
            </td><td style="padding: 5px;">
              $350 Allowance towards corrective eye surgery (LASIK, PRK, RK) every 48 months
            </td></tr>
          </table><br>`;
      case 6015:
        return `
          <table style="width: 100%; font-size: 11px; border-collapse: collapse; border: 1px solid #ccc;">
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td colspan="3" style="padding: 5px; text-align: center;">Summary of Benefits</td>
            </tr>
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td style="padding: 5px;"></td><td style="padding: 5px;">In Network</td><td style="padding: 5px;">Out of Network</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(217, 217, 217);"><td style="text-align: left; padding: 5px;">Exams: Every 12 months</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Routine Eye Exam</td><td style="padding: 5px;">Fully Covered</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Contact Lens Fitting</td><td style="padding: 5px;">No Coverage</td><td style="padding: 5px;">No Coverage</td></tr>

            <tr style="font-weight: bold; background-color: rgb(217, 217, 217);"><td style="text-align: left; padding: 5px;">Frames: Every 24 months</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Frames</td><td style="padding: 5px;">$100 Allowance<br>20% Off Overage</td><td style="padding: 5px;">No Coverage</td></tr>

            <tr style="font-weight: bold; background-color: rgb(217, 217, 217);"><td style="text-align: left; padding: 5px;">Lenses: Every 24 months</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Single Vision (Plastic)</td><td style="padding: 5px;">Fully Covered</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Bifocal (Plastic)</td><td style="padding: 5px;">Fully Covered</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Trifocal (Plastic)</td><td style="padding: 5px;">Fully Covered</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Standard Progressive (Plastic)</td><td style="padding: 5px;">Fully Covered</td><td style="padding: 5px;">No Coverage</td></tr>

            <tr style="font-weight: bold; background-color: rgb(217, 217, 217);"><td style="text-align: left; padding: 5px;">Contact Lenses: Every 24 months</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Elective (In Lieu of Glasses, Services inc)</td><td style="padding: 5px;">$100 Allowance</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Medical (Authorization Required)</td><td style="padding: 5px;">Fully Covered</td><td style="padding: 5px;">Fully Covered</td></tr>

            <tr style="font-weight: bold; background-color: rgb(217, 217, 217);"><td style="text-align: left; padding: 5px;">Lens Options</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Advanced Lens Designs</td><td style="padding: 5px;">20% off Overage</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Other Materials (Poly, High Index, Trivex)</td><td style="padding: 5px;">20% off Overage</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Solid Tints</td><td style="padding: 5px;">Fully Covered</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Gradient Tints</td><td style="padding: 5px;">20% off Overage</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Standard AR Coating</td><td style="padding: 5px;">20% off Overage</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Premium AR Coating</td><td style="padding: 5px;">20% off Overage</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Transition</td><td style="padding: 5px;">20% off Overage</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Polarized</td><td style="padding: 5px;">20% off Overage</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">All Other Options Not Listed</td><td style="padding: 5px;">20% off Overage</td><td style="padding: 5px;">No Coverage</td></tr>
          </table><br>`;
      case 18965:
        return `
          <table style="width: 100%; font-size: 11px; border-collapse: collapse; border: 1px solid #ccc;">
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td colspan="3" style="padding: 5px; text-align: center;">Summary of Benefits</td>
            </tr>
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td style="padding: 5px;"></td>
              <td style="padding: 5px;">In Network</td>
              <td style="padding: 5px;">Out of Network</td>
            </tr>

            <!-- Exams -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Exams: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Routine Eye Exam</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Contact Lens Fitting</td>
              <td style="padding: 5px;">No Coverage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Frames -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Frames: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Frames</td>
              <td style="padding: 5px;">
                $60 Allowance<br>
                20% Off Overage
              </td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Lenses -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lenses: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Single Vision (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Bifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Trifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard Progressive (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Contact Lenses -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 237);">
              <td colspan="3" style="text-align: left; padding: 5px;">Contact Lenses: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Elective (In Lieu of Glasses; Services inc)</td>
              <td style="padding: 5px;">$100 Allowance</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Medical (Authorization Required)</td>
              <td style="padding: 5px;">$275 Allowance</td>
              <td style="padding: 5px;">$275 Allowance</td>
            </tr>

            <!-- Lens Options -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lens Options</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Advanced Lens Designs</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Other Materials (Poly, High Index, Trivex)</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Solid Tints</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Gradient Tints</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Premium AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Transition</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Polarized</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">All Other Options Not Listed</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
          </table><br>`;
      case 19065:
        return `
          <table style="width: 100%; font-size: 11px; border-collapse: collapse; border: 1px solid #ccc;">
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td colspan="3" style="padding: 5px; text-align: center;">Summary of Benefits</td>
            </tr>
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td style="padding: 5px;"></td>
              <td style="padding: 5px;">In Network</td>
              <td style="padding: 5px;">Out of Network</td>
            </tr>

            <!-- Exams -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Exams: Every 24 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Routine Eye Exam</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Contact Lens Fitting</td>
              <td style="padding: 5px;">No Coverage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Frames -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Frames: Every 24 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Frames</td>
              <td style="padding: 5px;">$50 Allowance<br>20% Off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Lenses -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lenses: Every 24 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Single Vision (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Bifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Trifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard Progressive (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Contact Lenses -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Contact Lenses: Every 24 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Elective (In Lieu of Glasses; Services inc)</td>
              <td style="padding: 5px;">$100 Allowance</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Medical (Authorization Required)</td>
              <td style="padding: 5px;">$250 Allowance</td>
              <td style="padding: 5px;">$250 Allowance</td>
            </tr>

            <!-- Lens Options -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lens Options</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Advanced Lens Designs</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Other Materials (Poly, High Index, Trivex)</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Solid Tints</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Gradient Tints</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Premium AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Transition</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Polarized</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">All Other Options Not Listed</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
          </table><br>`;
      case 19095:
        return `
          <table style="width: 100%; font-size: 11px; border-collapse: collapse; border: 1px solid #ccc;">
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td colspan="3" style="padding: 5px; text-align: center;">Summary of Benefits</td>
            </tr>
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td style="padding: 5px;"></td><td style="padding: 5px;">In Network</td><td style="padding: 5px;">Out of Network</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);"><td colspan="3" style="text-align: left; padding: 5px;">Exams: Every 12 months</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Routine Eye Exam</td><td style="padding: 5px;">Fully Covered</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Contact Lens Fitting</td><td style="padding: 5px;">No Coverage</td><td style="padding: 5px;">No Coverage</td></tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);"><td colspan="3" style="text-align: left; padding: 5px;">Frames: Every 24 months</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Frames</td><td style="padding: 5px;">$50 Allowance<br>20% Off Overage</td><td style="padding: 5px;">No Coverage</td></tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);"><td colspan="3" style="text-align: left; padding: 5px;">Lenses: Every 24 months</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Single Vision (Plastic)</td><td style="padding: 5px;">Fully Covered</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Bifocal (Plastic)</td><td style="padding: 5px;">Fully Covered</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Trifocal (Plastic)</td><td style="padding: 5px;">Fully Covered</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Standard Progressive (Plastic)</td><td style="padding: 5px;">Fully Covered</td><td style="padding: 5px;">No Coverage</td></tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);"><td colspan="3" style="text-align: left; padding: 5px;">Contact Lenses: Every 24 months</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Elective (In Lieu of Glasses; Services incl)</td><td style="padding: 5px;">$100 Allowance</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Medical (Authorization Required)</td><td style="padding: 5px;">$250 Allowance</td><td style="padding: 5px;">$250 Allowance</td></tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);"><td colspan="3" style="text-align: left; padding: 5px;">Lens Options</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Advanced Lens Designs</td><td style="padding: 5px;">20% off Overage</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Other Materials (Poly, High Index, Trivex)</td><td style="padding: 5px;">20% off Overage</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Solid Tints</td><td style="padding: 5px;">Fully Covered</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Gradient Tints</td><td style="padding: 5px;">20% off Overage</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Standard AR Coating</td><td style="padding: 5px;">20% off Overage</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Premium AR Coating</td><td style="padding: 5px;">20% off Overage</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Transition</td><td style="padding: 5px;">20% off Overage</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Polarized</td><td style="padding: 5px;">20% off Overage</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">All Other Options Not Listed</td><td style="padding: 5px;">20% off Overage</td><td style="padding: 5px;">No Coverage</td></tr>
          </table><br>`;
      case 19415:
        return `
          <table style="width: 100%; font-size: 11px; border-collapse: collapse; border: 1px solid #ccc;">
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td colspan="3" style="padding: 5px; text-align: center;">Summary of Benefits</td>
            </tr>
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td style="padding: 5px;"></td><td style="padding: 5px;">In Network</td><td style="padding: 5px;">Out of Network</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Exams: Every 12 months</td>
            </tr>
            <tr><td style="text-align: left; padding: 5px;">Routine Eye Exam</td><td style="padding: 5px;">Fully Covered</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Contact Lens Fitting</td><td style="padding: 5px;">No Coverage</td><td style="padding: 5px;">No Coverage</td></tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Frames: Every 12 months</td>
            </tr>
            <tr><td style="text-align: left; padding: 5px;">Frames</td><td style="padding: 5px;">$75 Allowance<br>20% Off Overage</td><td style="padding: 5px;">No Coverage</td></tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lenses: Every 12 months</td>
            </tr>
            <tr><td style="text-align: left; padding: 5px;">Single Vision (Plastic)</td><td style="padding: 5px;">Fully Covered</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Bifocal (Plastic)</td><td style="padding: 5px;">Fully Covered</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Trifocal (Plastic)</td><td style="padding: 5px;">Fully Covered</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Standard Progressive (Plastic)</td><td style="padding: 5px;">Fully Covered</td><td style="padding: 5px;">No Coverage</td></tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Contact Lenses: Every 12 months</td>
            </tr>
            <tr><td style="text-align: left; padding: 5px;">Elective (In Lieu of Glasses, Services inc)</td><td style="padding: 5px;">$100 Allowance</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Medical (Authorization Required)</td><td style="padding: 5px;">$250 Allowance</td><td style="padding: 5px;">$250 Allowance</td></tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lens Options</td>
            </tr>
            <tr><td style="text-align: left; padding: 5px;">Advanced Lens Designs</td><td style="padding: 5px;">20% off Overage</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Other Materials (Poly, High Index, Trivex)</td><td style="padding: 5px;">20% off Overage</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Solid Tints</td><td style="padding: 5px;">Fully Covered</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Gradient Tints</td><td style="padding: 5px;">20% off Overage</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Standard AR Coating</td><td style="padding: 5px;">20% off Overage</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Premium AR Coating</td><td style="padding: 5px;">20% off Overage</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Transition</td><td style="padding: 5px;">20% off Overage</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Polarized</td><td style="padding: 5px;">20% off Overage</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">All Other Options Not Listed</td><td style="padding: 5px;">20% off Overage</td><td style="padding: 5px;">No Coverage</td></tr>
          </table><br>`;
      case 5995:
        return `
          <table style="width: 100%; font-size: 11px; border-collapse: collapse; border: 1px solid #ccc;">
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td colspan="3" style="padding: 5px; text-align: center;">Summary of Benefits</td>
            </tr>
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td style="padding: 5px;"></td>
              <td style="padding: 5px;">In Network</td>
              <td style="padding: 5px;">Out of Network</td>
            </tr>

            <!-- Exams -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Exams: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Routine Eye Exam</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Contact Lens Fitting</td>
              <td style="padding: 5px;">No Coverage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Frames -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Frames: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Frames</td>
              <td style="padding: 5px;">$50 Allowance<br>20% Off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Lenses -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lenses: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Single Vision (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Bifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Trifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard Progressive (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Contact Lenses -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Contact Lenses: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Elective (In Lieu of Glasses; Services inc)</td>
              <td style="padding: 5px;">$100 Allowance</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Medical (Authorization Required)</td>
              <td style="padding: 5px;">$250 Allowance</td>
              <td style="padding: 5px;">$250 Allowance</td>
            </tr>

            <!-- Lens Options -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lens Options</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Advanced Lens Designs</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Other Materials (Poly, High Index, Trivex)</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Solid Tints</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Gradient Tints</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Premium AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Transition</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Polarized</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">All Other Options Not Listed</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
          </table><br>`;
      case 6805:
        return `
          <table style="width: 100%; font-size: 11px; border-collapse: collapse; border: 1px solid #ccc;">
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td colspan="3" style="padding: 5px; text-align: center;">Summary of Benefits</td>
            </tr>
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td style="padding: 5px;"></td><td style="padding: 5px;">In Network</td><td style="padding: 5px;">Out of Network</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Exams: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Routine Eye Exam</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Contact Lens Fitting</td>
              <td style="padding: 5px;">No Coverage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Frames: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Frames</td>
              <td style="padding: 5px;">$50 Allowance<br>20% Off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lenses: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Single Vision (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Bifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Trifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard Progressive (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Contact Lenses: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Elective (In Lieu of Glasses, Services inc)</td>
              <td style="padding: 5px;">$100 Allowance</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Medical (Authorization Required)</td>
              <td style="padding: 5px;">$250 Allowance</td>
              <td style="padding: 5px;">$250 Allowance</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lens Options</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Advanced Lens Designs</td>
              <td style="padding: 5px;">20% Off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Other Materials (Poly, High Index, Trivex)</td>
              <td style="padding: 5px;">20% Off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Solid Tints</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Gradient Tints</td>
              <td style="padding: 5px;">20% Off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard AR Coating</td>
              <td style="padding: 5px;">20% Off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Premium AR Coating</td>
              <td style="padding: 5px;">20% Off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Transition</td>
              <td style="padding: 5px;">20% Off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Polarized</td>
              <td style="padding: 5px;">20% Off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">All Other Options Not Listed</td>
              <td style="padding: 5px;">20% Off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
          </table><br>`;
      case 6325:
        return `
          <table style="width: 100%; font-size: 11px; border-collapse: collapse; border: 1px solid #ccc;">
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td colspan="3" style="padding: 5px; text-align: center;">Summary of Benefits</td>
            </tr>
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td style="padding: 5px;"></td><td style="padding: 5px;">In Network</td><td style="padding: 5px;">Out of Network</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);"><td colspan="3" style="text-align: left; padding: 5px;">Exams: Every 24 months</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Routine Eye Exam</td><td style="padding: 5px;">Fully Covered</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Contact Lens Fitting</td><td style="padding: 5px;">No Coverage</td><td style="padding: 5px;">No Coverage</td></tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);"><td colspan="3" style="text-align: left; padding: 5px;">Frames: Every 24 months</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Frames</td><td style="padding: 5px;">$50 Allowance<br>20% Off Overage</td><td style="padding: 5px;">No Coverage</td></tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);"><td colspan="3" style="text-align: left; padding: 5px;">Lenses: Every 24 months</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Single Vision (Plastic)</td><td style="padding: 5px;">Fully Covered</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Bifocal (Plastic)</td><td style="padding: 5px;">Fully Covered</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Trifocal (Plastic)</td><td style="padding: 5px;">Fully Covered</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Standard Progressive (Plastic)</td><td style="padding: 5px;">Fully Covered</td><td style="padding: 5px;">No Coverage</td></tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);"><td colspan="3" style="text-align: left; padding: 5px;">Contact Lenses: Every 24 months</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Elective (In Lieu of Glasses; Services inc)</td><td style="padding: 5px;">$100 Allowance</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Medical (Authorization Required)</td><td style="padding: 5px;">$250 Allowance</td><td style="padding: 5px;">$250 Allowance</td></tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);"><td colspan="3" style="text-align: left; padding: 5px;">Lens Options</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Advanced Lens Designs</td><td style="padding: 5px;">20% off Overage</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Other Materials (Poly, High Index, Trivex)</td><td style="padding: 5px;">20% off Overage</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Solid Tints</td><td style="padding: 5px;">Fully Covered</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Gradient Tints</td><td style="padding: 5px;">20% off Overage</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Standard AR Coating</td><td style="padding: 5px;">20% off Overage</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Premium AR Coating</td><td style="padding: 5px;">20% off Overage</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Transition</td><td style="padding: 5px;">20% off Overage</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Polarized</td><td style="padding: 5px;">20% off Overage</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">All Other Options Not Listed</td><td style="padding: 5px;">20% off Overage</td><td style="padding: 5px;">No Coverage</td></tr>
          </table><br>`;
      case 7380:
        return `
          <table style="width: 100%; font-size: 11px; border-collapse: collapse; border: 1px solid #ccc;">
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td colspan="3" style="padding: 5px; text-align: center;">Summary of Benefits</td>
            </tr>
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td style="padding: 5px;"></td><td style="padding: 5px;">In Network</td><td style="padding: 5px;">Out of Network</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Exams: Every 24 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Routine Eye Exam</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Contact Lens Fitting</td>
              <td style="padding: 5px;">No Coverage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Frames: Every 24 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Frames</td>
              <td style="padding: 5px;">$50 Allowance<br>20% Off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lenses: Every 24 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Single Vision (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Bifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Trifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard Progressive (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Contact Lenses: Every 24 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Elective (In Lieu of Glasses; Services inc)</td>
              <td style="padding: 5px;">$100 Allowance</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Medical (Authorization Required)</td>
              <td style="padding: 5px;">$250 Allowance</td>
              <td style="padding: 5px;">$250 Allowance</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lens Options</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Advanced Lens Designs</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Other Materials (Poly, High Index, Trivex)</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Solid Tints</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Gradient Tints</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Premium AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Transition</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Polarized</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">All Other Options Not Listed</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
          </table><br>`;
      case 19595:
        return `
          <table style="width: 100%; font-size: 11px; border-collapse: collapse; border: 1px solid #ccc;">
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td colspan="3" style="padding: 5px; text-align: center;">Summary of Benefits</td>
            </tr>
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td style="padding: 5px;"></td><td style="padding: 5px;">In Network</td><td style="padding: 5px;">Out of Network</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Exams: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Routine Eye Exam</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Contact Lens Fitting</td>
              <td style="padding: 5px;">No Coverage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Frames: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Frames</td>
              <td style="padding: 5px;">$50 Allowance<br>20% Off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lenses: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Single Vision (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Bifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Trifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard Progressive (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Contact Lenses: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Elective (In Lieu of Glasses; Services inc)</td>
              <td style="padding: 5px;">$100 Allowance</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Medical (Authorization Required)</td>
              <td style="padding: 5px;">$250 Allowance</td>
              <td style="padding: 5px;">$250 Allowance</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lens Options</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Advanced Lens Designs</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Other Materials (Poly, High Index, Trivex)</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Solid Tints</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Gradient Tints</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Premium AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Transition</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Polarized</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">All Other Options Not Listed</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
          </table><br>`;
      case 4665:
        return `
          <table style="width: 100%; font-size: 11px; border-collapse: collapse; border: 1px solid #ccc;">
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td colspan="3" style="padding: 5px; text-align: center;">Summary of Benefits</td>
            </tr>
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td style="padding: 5px;"></td><td style="padding: 5px;">In Network</td><td style="padding: 5px;">Out of Network</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Exams: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Routine Eye Exam</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Contact Lens Fitting</td>
              <td style="padding: 5px;">No Coverage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Frames: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Frames</td>
              <td style="padding: 5px;">$50 Allowance<br>20% Off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lenses: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Single Vision (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Bifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Trifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard Progressive (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Contact Lenses: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Elective (In Lieu of Glasses; Services inc)</td>
              <td style="padding: 5px;">$100 Allowance</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Medical (Authorization Required)</td>
              <td style="padding: 5px;">$250 Allowance</td>
              <td style="padding: 5px;">$250 Allowance</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lens Options</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Advanced Lens Designs</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Other Materials (Poly, High Index, Trivex)</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Solid Tints</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Gradient Tints</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Premium AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Transition</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Polarized</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">All Other Options Not Listed</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
          </table><br>`;
      case 20005:
        return `
          <table style="width: 100%; font-size: 11px; border-collapse: collapse; border: 1px solid #ccc;">
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td colspan="3" style="padding: 5px; text-align: center;">Summary of Benefits</td>
            </tr>
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td style="padding: 5px;"></td><td style="padding: 5px;">In Network</td><td style="padding: 5px;">Out of Network</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Exams: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Routine Eye Exam</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Contact Lens Fitting</td>
              <td style="padding: 5px;">No Coverage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Frames: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Frames</td>
              <td style="padding: 5px;">$150 Allowance<br>20% Off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lenses: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Single Vision (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Bifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Trifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard Progressive (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Contact Lenses: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Elective (In Lieu of Glasses; Services inc)</td>
              <td style="padding: 5px;">$150 Allowance</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Medical (Authorization Required)</td>
              <td style="padding: 5px;">$250 Allowance</td>
              <td style="padding: 5px;">$250 Allowance</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lens Options</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Advanced Lens Designs</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Other Materials (Poly, High Index, Trivex)</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Solid Tints</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Gradient Tints</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Premium AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Transition</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Polarized</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">All Other Options Not Listed</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
          </table><br>`;
      case 19850:
        return `
          <table style="width: 100%; font-size: 11px; border-collapse: collapse; border: 1px solid #ccc;">
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td colspan="3" style="padding: 5px; text-align: center;">Summary of Benefits</td>
            </tr>
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td style="padding: 5px;"></td><td style="padding: 5px;">In Network</td><td style="padding: 5px;">Out of Network</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Exams: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Routine Eye Exam</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Contact Lens Fitting</td>
              <td style="padding: 5px;">No Coverage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Frames: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Frames</td>
              <td style="padding: 5px;">$50 Allowance<br>20% Off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lenses: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Single Vision (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Bifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Trifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard Progressive (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Contact Lenses: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Elective (In Lieu of Glasses; Services incl)</td>
              <td style="padding: 5px;">$100 Allowance</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Medical (Authorization Required)</td>
              <td style="padding: 5px;">$250 Allowance</td>
              <td style="padding: 5px;">$250 Allowance</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lens Options</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Advanced Lens Designs</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Other Materials (Poly, High Index, Trivex)</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Solid Tints</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Gradient Tints</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Premium AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Transition</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Polarized</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">All Other Options Not Listed</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
          </table><br>`;
      case 19900:
        return `
          <table style="width: 100%; font-size: 11px; border-collapse: collapse; border: 1px solid #ccc;">
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td colspan="3" style="padding: 5px; text-align: center;">Summary of Benefits</td>
            </tr>
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td style="padding: 5px;"></td>
              <td style="padding: 5px;">In Network</td>
              <td style="padding: 5px;">Out of Network</td>
            </tr>

            <!-- Exams -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Exams: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Routine Eye Exam</td>
              <td style="padding: 5px;">Fully Covered<br>$5 Copay</td>
              <td style="padding: 5px;">$45 Allowance</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Contact Lens Fitting</td>
              <td style="padding: 5px;">No Coverage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Frames -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Frames: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Frames</td>
              <td style="padding: 5px;">
                $130 Allowance<br>
                20% Off Overage<br>
                $10 Material Copay
              </td>
              <td style="padding: 5px;">
                $49 Allowance<br>
                $10 Material Copay
              </td>
            </tr>

            <!-- Lenses -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lenses: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Single Vision (Plastic)</td>
              <td style="padding: 5px;">$10 Material Copay</td>
              <td style="padding: 5px;">$59 Allowance<br>$10 Material Copay</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Bifocal (Plastic)</td>
              <td style="padding: 5px;">$10 Material Copay</td>
              <td style="padding: 5px;">$79 Allowance<br>$10 Material Copay</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Trifocal (Plastic)</td>
              <td style="padding: 5px;">$10 Material Copay</td>
              <td style="padding: 5px;">$99 Allowance<br>$10 Material Copay</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard Progressive (Plastic)</td>
              <td style="padding: 5px;">$10 Material Copay</td>
              <td style="padding: 5px;">$99 Allowance<br>$10 Material Copay</td>
            </tr>

            <!-- Contact Lenses -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 237);">
              <td colspan="3" style="text-align: left; padding: 5px;">Contact Lenses: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Elective (In Lieu of Glasses; Services incl)</td>
              <td style="padding: 5px;">
                $50 Allowance<br>
                $10 Material Copay
              </td>
              <td style="padding: 5px;">
                $89 Allowance<br>
                $10 Material Copay
              </td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Medical (Authorization Required)</td>
              <td style="padding: 5px;">$250 Allowance</td>
              <td style="padding: 5px;">$210 Allowance</td>
            </tr>

            <!-- Lens Options -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lens Options</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Advanced Lens Designs</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Other Materials (Poly, High Index, Trivex)</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Solid Tints</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">Fully Covered</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Gradient Tints</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Premium AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Transition</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Polarized</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">All Other Options Not Listed</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
          </table><br>`;
      case 7300:
        return `
          <table style="width: 100%; font-size: 11px; border-collapse: collapse; border: 1px solid #ccc;">
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td colspan="3" style="padding: 5px; text-align: center;">Summary of Benefits</td>
            </tr>
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td style="padding: 5px;"></td>
              <td style="padding: 5px;">In Network</td>
              <td style="padding: 5px;">Out of Network</td>
            </tr>

            <!-- Exams -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Exams: Every Calendar Year</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Routine Eye Exam</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Contact Lens Fitting</td>
              <td style="padding: 5px;">No Coverage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Frames -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Frames: Every Calendar Year</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Frames</td>
              <td style="padding: 5px;">
                $24 Allowance<br>
                20% Off Overage
              </td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Lenses -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lenses: Every Calendar Year</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Single Vision (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Bifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Trifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard Progressive (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Contact Lenses -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 237);">
              <td colspan="3" style="text-align: left; padding: 5px;">Contact Lenses: Every Calendar Year</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Elective (In Lieu of Glasses; Services inc)</td>
              <td style="padding: 5px;">$120 Allowance</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Medical (Authorization Required)</td>
              <td style="padding: 5px;">$250 Allowance</td>
              <td style="padding: 5px;">$250 Allowance</td>
            </tr>

            <!-- Lens Options -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lens Options</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Advanced Lens Designs</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Other Materials (Poly, High Index, Trivex)</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Solid Tints</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Gradient Tints</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Premium AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Transition</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Polarized</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">All Other Options Not Listed</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
          </table><br>`;
      case 19355:
        return `
          <table style="width: 100%; font-size: 11px; border-collapse: collapse; border: 1px solid #ccc;">
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td colspan="3" style="padding: 5px; text-align: center;">Summary of Benefits</td>
            </tr>
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td style="padding: 5px;"></td>
              <td style="padding: 5px;">In Network</td>
              <td style="padding: 5px;">Out of Network</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Exams: Every Calendar Year</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Routine Eye Exam</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Contact Lens Fitting</td>
              <td style="padding: 5px;">No Coverage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Frames: Every Calendar Year</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Frames</td>
              <td style="padding: 5px;">
                $24 Allowance<br>
                20% Off Overage
              </td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lenses: Every Calendar Year</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Single Vision (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Bifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Trifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard Progressive (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Contact Lenses: Every Calendar Year</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Elective (In Lieu of Glasses, Services inc)</td>
              <td style="padding: 5px;">$120 Allowance</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Medical (Authorization Required)</td>
              <td style="padding: 5px;">$250 Allowance</td>
              <td style="padding: 5px;">$250 Allowance</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lens Options</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Advanced Lens Designs</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Other Materials (Poly, High Index, Trivex)</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Solid Tints</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Gradient Tints</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Premium AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Transition</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Polarized</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">All Other Options Not Listed</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
          </table><br>`;
      case 4965:
        return `
          <table style="width: 100%; font-size: 11px; border-collapse: collapse; border: 1px solid #ccc;">
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td colspan="3" style="padding: 5px; text-align: center;">Summary of Benefits</td>
            </tr>
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td style="padding: 5px;"></td><td style="padding: 5px;">In Network</td><td style="padding: 5px;">Out of Network</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Exams: Every 24 months</td>
            </tr>
            <tr><td style="text-align: left; padding: 5px;">Routine Eye Exam</td><td style="padding: 5px;">Fully Covered</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Contact Lens Fitting</td><td style="padding: 5px;">No Coverage</td><td style="padding: 5px;">No Coverage</td></tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Frames: Every 24 months</td>
            </tr>
            <tr><td style="text-align: left; padding: 5px;">Frames</td><td style="padding: 5px;">$50 Allowance<br>20% Off Overage</td><td style="padding: 5px;">No Coverage</td></tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lenses: Every 24 months</td>
            </tr>
            <tr><td style="text-align: left; padding: 5px;">Single Vision (Plastic)</td><td style="padding: 5px;">Fully Covered</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Bifocal (Plastic)</td><td style="padding: 5px;">Fully Covered</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Trifocal (Plastic)</td><td style="padding: 5px;">Fully Covered</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Standard Progressive (Plastic)</td><td style="padding: 5px;">Fully Covered</td><td style="padding: 5px;">No Coverage</td></tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Contact Lenses: Every 24 months</td>
            </tr>
            <tr><td style="text-align: left; padding: 5px;">Elective (In Lieu of Glasses; Services inc)</td><td style="padding: 5px;">$100 Allowance</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Medical (Authorization Required)</td><td style="padding: 5px;">$250 Allowance</td><td style="padding: 5px;">$250 Allowance</td></tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lens Options</td>
            </tr>
            <tr><td style="text-align: left; padding: 5px;">Advanced Lens Designs</td><td style="padding: 5px;">20% off Overage</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Other Materials (Poly, High Index, Trivex)</td><td style="padding: 5px;">20% off Overage</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Solid Tints</td><td style="padding: 5px;">Fully Covered</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Gradient Tints</td><td style="padding: 5px;">20% off Overage</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Standard AR Coating</td><td style="padding: 5px;">20% off Overage</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Premium AR Coating</td><td style="padding: 5px;">20% off Overage</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Transition</td><td style="padding: 5px;">20% off Overage</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Polarized</td><td style="padding: 5px;">20% off Overage</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">All Other Options Not Listed</td><td style="padding: 5px;">20% off Overage</td><td style="padding: 5px;">No Coverage</td></tr>
          </table><br>`;
      case 7020:
        return `
          <table style="width: 100%; font-size: 11px; border-collapse: collapse; border: 1px solid #ccc;">
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td colspan="3" style="padding: 5px; text-align: center;">Summary of Benefits</td>
            </tr>
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td style="padding: 5px;"></td>
              <td style="padding: 5px;">In Network</td>
              <td style="padding: 5px;">Out of Network</td>
            </tr>

            <!-- Exams -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Exams: Every 24 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Routine Eye Exam</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Contact Lens Fitting</td>
              <td style="padding: 5px;">No Coverage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Frames -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Frames: Every 24 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Frames</td>
              <td style="padding: 5px;">
                $50 Allowance<br>
                20% Off Overage
              </td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Lenses -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lenses: Every 24 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Single Vision (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Bifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Trifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard Progressive (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Contact Lenses -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Contact Lenses: Every 24 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Elective (In Lieu of Glasses; Services inc)</td>
              <td style="padding: 5px;">$100 Allowance</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Medical (Authorization Required)</td>
              <td style="padding: 5px;">$250 Allowance</td>
              <td style="padding: 5px;">$250 Allowance</td>
            </tr>

            <!-- Lens Options -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lens Options</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Advanced Lens Designs</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Other Materials (Poly, High Index, Trivex)</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Solid Tints</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Gradient Tints</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Premium AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Transition</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Polarized</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">All Other Options Not Listed</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
          </table><br>`;
      case 18910:
        return `
          <table style="width: 100%; font-size: 11px; border-collapse: collapse; border: 1px solid #ccc;">
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td colspan="3" style="padding: 5px; text-align: center;">Summary of Benefits</td>
            </tr>
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td style="padding: 5px;"></td>
              <td style="padding: 5px;">In Network</td>
              <td style="padding: 5px;">Out of Network</td>
            </tr>

            <!-- Exams -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Exams: Every 24 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Routine Eye Exam</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Contact Lens Fitting</td>
              <td style="padding: 5px;">No Coverage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Frames -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Frames: Every 24 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Frames</td>
              <td style="padding: 5px;">
                $50 Allowance<br>
                20% Off Overage
              </td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Lenses -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lenses: Every 24 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Single Vision (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Bifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Trifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard Progressive (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Contact Lenses -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Contact Lenses: Every 24 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Elective (In Lieu of Glasses; Services inc)</td>
              <td style="padding: 5px;">$100 Allowance</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Medical (Authorization Required)</td>
              <td style="padding: 5px;">$250 Allowance</td>
              <td style="padding: 5px;">$250 Allowance</td>
            </tr>

            <!-- Lens Options -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lens Options</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Advanced Lens Designs</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Other Materials (Poly, High Index, Trivex)</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Solid Tints</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Gradient Tints</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Premium AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Transition</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Polarized</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">All Other Options Not Listed</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
          </table><br>`;
      case 7520:
        return `
          <table style="width: 100%; font-size: 11px; border-collapse: collapse; border: 1px solid #ccc;">
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td colspan="3" style="padding: 5px; text-align: center;">Summary of Benefits</td>
            </tr>
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td style="padding: 5px;"></td>
              <td style="padding: 5px;">In Network</td>
              <td style="padding: 5px;">Out of Network</td>
            </tr>

            <!-- Exams -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Exams: Every 24 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Routine Eye Exam</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Contact Lens Fitting</td>
              <td style="padding: 5px;">No Coverage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Frames -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Frames: Every 24 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Frames</td>
              <td style="padding: 5px;">$50 Allowance<br>20% Off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Lenses -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lenses: Every 24 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Single Vision (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Bifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Trifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard Progressive (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Contact Lenses -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Contact Lenses: Every 24 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Elective (In Lieu of Glasses; Services inc)</td>
              <td style="padding: 5px;">$100 Allowance</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Medical (Authorization Required)</td>
              <td style="padding: 5px;">$250 Allowance</td>
              <td style="padding: 5px;">$250 Allowance</td>
            </tr>

            <!-- Lens Options -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lens Options</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Advanced Lens Designs</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Other Materials (Poly, High Index, Trivex)</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Solid Tints</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Gradient Tints</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Premium AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Transition</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Polarized</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">All Other Options Not Listed</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
          </table><br>`;
      case 7160:
        return `
          <table style="width: 100%; font-size: 11px; border-collapse: collapse; border: 1px solid #ccc;">
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td colspan="3" style="padding: 5px; text-align: center;">Summary of Benefits</td>
            </tr>
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td style="padding: 5px;"></td>
              <td style="padding: 5px;">In Network</td>
              <td style="padding: 5px;">Out of Network</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Exams: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Routine Eye Exam</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Contact Lens Fitting</td>
              <td style="padding: 5px;">No Coverage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Frames: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Frames</td>
              <td style="padding: 5px;">$50 Allowance<br>20% Off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lenses: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Single Vision (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Bifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Trifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard Progressive (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Contact Lenses: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Elective (In Lieu of Glasses; Services inc)</td>
              <td style="padding: 5px;">$100 Allowance</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Medical (Authorization Required)</td>
              <td style="padding: 5px;">$250 Allowance</td>
              <td style="padding: 5px;">$250 Allowance</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lens Options</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Advanced Lens Designs</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Other Materials (Poly, High Index, Trivex)</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Solid Tints</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Gradient Tints</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Premium AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Transition</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Polarized</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">All Other Options Not Listed</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
          </table><br>`;
      case 4975:
        return `
          <table style="width: 100%; font-size: 11px; border-collapse: collapse; border: 1px solid #ccc;">
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td colspan="3" style="padding: 5px; text-align: center;">Summary of Benefits</td>
            </tr>
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td style="padding: 5px;"></td>
              <td style="padding: 5px;">In Network</td>
              <td style="padding: 5px;">Out of Network</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Exams: Every 24 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Routine Eye Exam</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Contact Lens Fitting</td>
              <td style="padding: 5px;">No Coverage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Frames: Every 24 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Frames</td>
              <td style="padding: 5px;">$50 Allowance<br>20% Off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lenses: Every 24 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Single Vision (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Bifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Trifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard Progressive (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Contact Lenses: Every 24 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Elective (In Lieu of Glasses; Services inc)</td>
              <td style="padding: 5px;">$100 Allowance</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Medical (Authorization Required)</td>
              <td style="padding: 5px;">$250 Allowance</td>
              <td style="padding: 5px;">$250 Allowance</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lens Options</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Advanced Lens Designs</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Other Materials (Poly, High Index, Trivex)</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Solid Tints</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Gradient Tints</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Premium AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Transition</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Polarized</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">All Other Options Not Listed</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
          </table><br>`;
      case 19990:
        return `
          <table style="width: 100%; font-size: 11px; border-collapse: collapse; border: 1px solid #ccc;">
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td colspan="3" style="padding: 5px; text-align: center;">Summary of Benefits</td>
            </tr>
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td style="padding: 5px;"></td>
              <td style="padding: 5px;">In Network</td>
              <td style="padding: 5px;">Out of Network</td>
            </tr>

            <!-- Exams -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Exams: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Routine Eye Exam</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Contact Lens Fitting</td>
              <td style="padding: 5px;">30% off Usual &amp; Customary</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Frames -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Frames: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Frames</td>
              <td style="padding: 5px;">
                $200 Allowance<br>
                20% Off Overage
              </td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Lenses -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lenses: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Single Vision (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Bifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Trifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard Progressive (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Contact Lenses -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 237);">
              <td colspan="3" style="text-align: left; padding: 5px;">Contact Lenses: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Elective (In Lieu of Glasses; Services inc)</td>
              <td style="padding: 5px;">
                $200 Allowance<br>
                20% off Overage
              </td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Medical (Authorization Required)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">Fully Covered</td>
            </tr>

            <!-- Lens Options -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lens Options</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Advanced Lens Designs</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Other Materials (Poly, High Index, Trivex)</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Solid Tints</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Gradient Tints</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Premium AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Transition</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Polarized</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <tr>
              <td style="text-align: left; padding: 5px;">All Other Options Not Listed</td>
              <td style="padding: 5px;">
                Poly fully covered for children under 18;<br>
                At Shopko Optical, SV SmartLife Ind Hi Index, PRG SmartLife Indi Hi Index and anti-reflective DuraVision Platinum, or Smart Life Young for children under 18 only fully covered;<br>
                At SVS Vision, SV Eydef TruView 2.0 1.67 Clear, PRG EyeDef Intellilens 2.0 1.67 Clear and anti-reflective Reveal, or Eye Def Tru View 2.0 Poly for children under 18 only, fully covered;<br>
                20% off Overage
              </td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
          </table><br>`;
      case 9400:
        return `
          <table style="width: 100%; font-size: 11px; border-collapse: collapse; border: 1px solid #ccc;">
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td colspan="3" style="padding: 5px; text-align: center;">Summary of Benefits</td>
            </tr>
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td style="padding: 5px;"></td>
              <td style="padding: 5px;">In Network</td>
              <td style="padding: 5px;">Out of Network</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Exams: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Routine Eye Exam</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Contact Lens Fitting</td>
              <td style="padding: 5px;">No Coverage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Frames: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Frames</td>
              <td style="padding: 5px;">$50 Allowance<br>20% Off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lenses: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Single Vision (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Bifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Trifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard Progressive (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Contact Lenses: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Elective (In Lieu of Glasses; Services inc)</td>
              <td style="padding: 5px;">$100 Allowance</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Medical (Authorization Required)</td>
              <td style="padding: 5px;">$250 Allowance</td>
              <td style="padding: 5px;">$250 Allowance</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lens Options</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Advanced Lens Designs</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Other Materials (Poly, High Index, Trivex)</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Solid Tints</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Gradient Tints</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Premium AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Transition</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Polarized</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">All Other Options Not Listed</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
          </table><br>`;
      case 19775:
        return `
          <table style="width: 100%; font-size: 11px; border-collapse: collapse; border: 1px solid #ccc;">
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td colspan="3" style="padding: 5px; text-align: center;">Summary of Benefits</td>
            </tr>
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td style="padding: 5px;"></td>
              <td style="padding: 5px;">In Network</td>
              <td style="padding: 5px;">Out of Network</td>
            </tr>

            <!-- Exams -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Exams: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Routine Eye Exam</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Contact Lens Fitting</td>
              <td style="padding: 5px;">No Coverage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Frames -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Frames: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Frames</td>
              <td style="padding: 5px;">
                $75 Allowance<br>
                20% Off Overage
              </td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Lenses -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lenses: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Single Vision (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Bifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Trifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard Progressive (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Contact Lenses -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Contact Lenses: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Elective (In Lieu of Glasses; Services inc)</td>
              <td style="padding: 5px;">$100 Allowance</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Medical (Authorization Required)</td>
              <td style="padding: 5px;">$250 Allowance</td>
              <td style="padding: 5px;">$250 Allowance</td>
            </tr>

            <!-- Lens Options -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lens Options</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Advanced Lens Designs</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Other Materials (Poly, High Index, Trivex)</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Solid Tints</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Gradient Tints</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Premium AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Transition</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Polarized</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">All Other Options Not Listed</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
          </table><br>`;
      case 19880:
        return `
          <table style="width: 100%; font-size: 11px; border-collapse: collapse; border: 1px solid #ccc;">
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td colspan="3" style="padding: 5px; text-align: center;">Summary of Benefits</td>
            </tr>
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td style="padding: 5px;"></td>
              <td style="padding: 5px;">In Network</td>
              <td style="padding: 5px;">Out of Network</td>
            </tr>

            <!-- Exams -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Exams: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Routine Eye Exam</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Contact Lens Fitting</td>
              <td style="padding: 5px;">No Coverage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Frames -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Frames: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Frames</td>
              <td style="padding: 5px;">
                $50 Allowance<br>
                20% Off Overage
              </td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Lenses -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lenses: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Single Vision (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Bifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Trifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard Progressive (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Contact Lenses -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Contact Lenses: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Elective (In Lieu of Glasses; Services inc)</td>
              <td style="padding: 5px;">$100 Allowance</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Medical (Authorization Required)</td>
              <td style="padding: 5px;">$250 Allowance</td>
              <td style="padding: 5px;">$250 Allowance</td>
            </tr>

            <!-- Lens Options -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lens Options</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Advanced Lens Designs</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Other Materials (Poly, High Index, Trivex)</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Solid Tints</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Gradient Tints</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Premium AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Transition</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Polarized</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">All Other Options Not Listed</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
          </table><br>`;
      case 6825:
        return `
          <table style="width: 100%; font-size: 11px; border-collapse: collapse; border: 1px solid #ccc;">
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td colspan="3" style="padding: 5px; text-align: center;">Summary of Benefits</td>
            </tr>
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td style="padding: 5px;"></td>
              <td style="padding: 5px;">In Network</td>
              <td style="padding: 5px;">Out of Network</td>
            </tr>

            <!-- Exams -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Exams: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Routine Eye Exam</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Contact Lens Fitting</td>
              <td style="padding: 5px;">No Coverage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Frames -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Frames: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Frames</td>
              <td style="padding: 5px;">$50 Allowance<br>20% Off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Lenses -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lenses: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Single Vision (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Bifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Trifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard Progressive (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Contact Lenses -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Contact Lenses: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Elective (In Lieu of Glasses; Services inc)</td>
              <td style="padding: 5px;">$100 Allowance</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Medical (Authorization Required)</td>
              <td style="padding: 5px;">$250 Allowance</td>
              <td style="padding: 5px;">$250 Allowance</td>
            </tr>

            <!-- Lens Options -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lens Options</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Advanced Lens Designs</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Other Materials (Poly, High Index, Trivex)</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Solid Tints</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Gradient Tints</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Premium AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Transition</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Polarized</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">All Other Options Not Listed</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
          </table><br>`;
      case 7525:
        return `
          <table style="width: 100%; font-size: 11px; border-collapse: collapse; border: 1px solid #ccc;">
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td colspan="3" style="padding: 5px; text-align: center;">Summary of Benefits</td>
            </tr>
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td style="padding: 5px;"></td>
              <td style="padding: 5px;">In Network</td>
              <td style="padding: 5px;">Out of Network</td>
            </tr>

            <!-- Exams -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Exams: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Routine Eye Exam</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Contact Lens Fitting</td>
              <td style="padding: 5px;">No Coverage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Frames -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Frames: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Frames</td>
              <td style="padding: 5px;">$50 Allowance<br>20% Off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Lenses -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lenses: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Single Vision (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Bifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Trifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard Progressive (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Contact Lenses -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Contact Lenses: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Elective (In Lieu of Glasses; Services inc)</td>
              <td style="padding: 5px;">$100 Allowance</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Medical (Authorization Required)</td>
              <td style="padding: 5px;">$250 Allowance</td>
              <td style="padding: 5px;">$250 Allowance</td>
            </tr>

            <!-- Lens Options -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lens Options</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Advanced Lens Designs</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Other Materials (Poly, High Index, Trivex)</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Solid Tints</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Gradient Tints</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Premium AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Transition</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Polarized</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">All Other Options Not Listed</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
          </table><br>`;
      case 6600:
        return `
          <table style="width: 100%; font-size: 11px; border-collapse: collapse; border: 1px solid #ccc;">
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td colspan="3" style="padding: 5px; text-align: center;">Summary of Benefits</td>
            </tr>
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td style="padding: 5px;"></td>
              <td style="padding: 5px;">In Network</td>
              <td style="padding: 5px;">Out of Network</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Exams: Every 24 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Routine Eye Exam</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Contact Lens Fitting</td>
              <td style="padding: 5px;">No Coverage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Frames: Every 24 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Frames</td>
              <td style="padding: 5px;">$50 Allowance<br>20% Off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lenses: Every 24 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Single Vision (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Bifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Trifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard Progressive (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Contact Lenses: Every 24 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Elective (In Lieu of Glasses; Services inc)</td>
              <td style="padding: 5px;">$100 Allowance</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Medical (Authorization Required)</td>
              <td style="padding: 5px;">$250 Allowance</td>
              <td style="padding: 5px;">$250 Allowance</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lens Options</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Advanced Lens Designs</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Other Materials (Poly, High Index, Trivex)</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Solid Tints</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Gradient Tints</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Premium AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Transition</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Polarized</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">All Other Options Not Listed</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
          </table><br>`;
      case 20335:
        return `
          <table style="width: 100%; font-size: 11px; border-collapse: collapse; border: 1px solid #ccc;">
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td colspan="3" style="padding: 5px; text-align: center;">Summary of Benefits</td>
            </tr>
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td style="padding: 5px;"></td>
              <td style="padding: 5px;">In Network</td>
              <td style="padding: 5px;">Out of Network</td>
            </tr>

            <!-- Exams -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Exams: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Routine Eye Exam</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Contact Lens Fitting</td>
              <td style="padding: 5px;">No Coverage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Frames -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Frames: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Frames</td>
              <td style="padding: 5px;">
                $200 Allowance<br>
                20% off Overage
              </td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Lenses -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lenses: Every 24 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Single Vision (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Bifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Trifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard Progressive (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Contact Lenses -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 237);">
              <td colspan="3" style="text-align: left; padding: 5px;">Contact Lenses: Every 24 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Elective (In Lieu of Glasses; Services inc)</td>
              <td style="padding: 5px;">$200 Allowance</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Medical (Authorization Required)</td>
              <td style="padding: 5px;">$250 Allowance</td>
              <td style="padding: 5px;">$250 Allowance</td>
            </tr>

            <!-- Lens Options -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lens Options</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Advanced Lens Designs</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Other Materials (Poly, High Index, Trivex)</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Solid Tints</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Gradient Tints</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Premium AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Transition</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Polarized</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">All Other Options Not Listed</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
          </table><br>`;
      case 19975:
        return `
          <table style="width: 100%; font-size: 11px; border-collapse: collapse; border: 1px solid #ccc;">
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td colspan="3" style="padding: 5px; text-align: center;">Summary of Benefits</td>
            </tr>
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td style="padding: 5px;"></td>
              <td style="padding: 5px;">In Network</td>
              <td style="padding: 5px;">Out of Network</td>
            </tr>

            <!-- Exams -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Exams: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Routine Eye Exam</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Contact Lens Fitting</td>
              <td style="padding: 5px;">No Coverage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Frames -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Frames: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Frames</td>
              <td style="padding: 5px;">
                $130 Allowance<br>
                20% Off Overage
              </td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Lenses -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lenses: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Single Vision (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Bifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Trifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard Progressive (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Contact Lenses -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Contact Lenses: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Elective (In Lieu of Glasses; Services inc)</td>
              <td style="padding: 5px;">$130 Allowance</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Medical (Authorization Required)</td>
              <td style="padding: 5px;">$250 Allowance</td>
              <td style="padding: 5px;">$250 Allowance</td>
            </tr>

            <!-- Lens Options -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lens Options</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Advanced Lens Designs</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Other Materials (Poly, High Index, Trivex)</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Solid Tints</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Gradient Tints</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Premium AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Transition</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Polarized</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">All Other Options Not Listed</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
          </table><br>`;
      case 3860:
        return `
          <table style="width: 100%; font-size: 11px; border-collapse: collapse; border: 1px solid #ccc;">
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td colspan="3" style="padding: 5px; text-align: center;">Summary of Benefits</td>
            </tr>
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td style="padding: 5px;"></td>
              <td style="padding: 5px;">In Network</td>
              <td style="padding: 5px;">Out of Network</td>
            </tr>

            <!-- Exams -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Exams: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Routine Eye Exam</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Contact Lens Fitting</td>
              <td style="padding: 5px;">No Coverage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Frames -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Frames: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Frames</td>
              <td style="padding: 5px;">
                $50 Allowance<br>
                20% Off Overage
              </td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Lenses -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lenses: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Single Vision (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Bifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Trifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard Progressive (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Contact Lenses -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 237);">
              <td colspan="3" style="text-align: left; padding: 5px;">Contact Lenses: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Elective (In Lieu of Glasses; Services inc)</td>
              <td style="padding: 5px;">$100 Allowance</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Medical (Authorization Required)</td>
              <td style="padding: 5px;">$250 Allowance</td>
              <td style="padding: 5px;">$250 Allowance</td>
            </tr>

            <!-- Lens Options -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lens Options</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Advanced Lens Designs</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Other Materials (Poly, High Index, Trivex)</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Solid Tints</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Gradient Tints</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Premium AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Transition</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Polarized</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">All Other Options Not Listed</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
          </table><br>`;
      case 19650:
        return `
          <table style="width: 100%; font-size: 11px; border-collapse: collapse; border: 1px solid #ccc;">
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td colspan="3" style="padding: 5px; text-align: center;">Summary of Benefits</td>
            </tr>
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td style="padding: 5px;"></td>
              <td style="padding: 5px;">In Network</td>
              <td style="padding: 5px;">Out of Network</td>
            </tr>

            <!-- Exams -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Exams: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Routine Eye Exam</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Contact Lens Fitting</td>
              <td style="padding: 5px;">No Coverage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Frames -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Frames: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Frames</td>
              <td style="padding: 5px;">
                $75 Allowance<br>
                20% Off Overage
              </td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Lenses -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lenses: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Single Vision (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Bifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Trifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard Progressive (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Contact Lenses -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Contact Lenses: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Elective (In Lieu of Glasses; Services inc)</td>
              <td style="padding: 5px;">$100 Allowance</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Medical (Authorization Required)</td>
              <td style="padding: 5px;">$250 Allowance</td>
              <td style="padding: 5px;">$250 Allowance</td>
            </tr>

            <!-- Lens Options -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lens Options</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Advanced Lens Designs</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Other Materials (Poly, High Index, Trivex)</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Solid Tints</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Gradient Tints</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Premium AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Transition</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Polarized</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">All Other Options Not Listed</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
          </table><br>`;
      case 6765:
        return `
          <table style="width: 100%; font-size: 11px; border-collapse: collapse; border: 1px solid #ccc;">
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td colspan="3" style="padding: 5px; text-align: center;">Summary of Benefits</td>
            </tr>
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td style="padding: 5px;"></td>
              <td style="padding: 5px;">In Network</td>
              <td style="padding: 5px;">Out of Network</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Exams: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Routine Eye Exam</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Contact Lens Fitting</td>
              <td style="padding: 5px;">No Coverage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Frames: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Frames</td>
              <td style="padding: 5px;">
                $130 Allowance,<br>
                20% off Overage
              </td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lenses: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Single Vision (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Bifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Trifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard Progressive (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Contact Lenses: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Elective (In Lieu of Glasses, Services incl)</td>
              <td style="padding: 5px;">$130 Allowance</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Medical (Authorization Required)</td>
              <td style="padding: 5px;">$250 Allowance</td>
              <td style="padding: 5px;">$250 Allowance</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lens Options</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Advanced Lens Designs</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Other Materials (Poly, High Index, Trivex)</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Solid Tints</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Gradient Tints</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Premium AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Transition</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Polarized</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">All Other Options Not Listed</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
          </table><br>`;
      case 6755:
        return `
          <table style="width: 100%; font-size: 11px; border-collapse: collapse; border: 1px solid #ccc;">
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td colspan="3" style="padding: 5px; text-align: center;">Summary of Benefits</td>
            </tr>
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td style="padding: 5px;"></td><td style="padding: 5px;">In Network</td><td style="padding: 5px;">Out of Network</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Exams: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Routine Eye Exam</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Contact Lens Fitting</td>
              <td style="padding: 5px;">No Coverage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Frames: Every 24 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Frames</td>
              <td style="padding: 5px;">$50 Allowance<br>20% Off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lenses: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Single Vision (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Bifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Trifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard Progressive (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Contact Lenses: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Elective (In Lieu of Glasses, Services inc)</td>
              <td style="padding: 5px;">$100 Allowance</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Medical (Authorization Required)</td>
              <td style="padding: 5px;">$250 Allowance</td>
              <td style="padding: 5px;">$250 Allowance</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lens Options</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Advanced Lens Designs</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Other Materials (Poly, High Index, Trivex)</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Solid Tints</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Gradient Tints</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Premium AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Transition</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Polarized</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">All Other Options Not Listed</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
          </table><br>`;
      case 7335:
        return `
          <table style="width: 100%; font-size: 11px; border-collapse: collapse; border: 1px solid #ccc;">
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td colspan="3" style="padding: 5px; text-align: center;">Summary of Benefits</td>
            </tr>
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td style="padding: 5px;"></td>
              <td style="padding: 5px;">In Network</td>
              <td style="padding: 5px;">Out of Network</td>
            </tr>

            <!-- Exams -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Exams: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Routine Eye Exam</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Contact Lens Fitting</td>
              <td style="padding: 5px;">No Coverage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Frames -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Frames: Every 24 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Frames</td>
              <td style="padding: 5px;">
                $50 Allowance<br>
                20% Off Overage
              </td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Lenses -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lenses: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Single Vision (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Bifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Trifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard Progressive (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Contact Lenses -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Contact Lenses: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Elective (In Lieu of Glasses; Services inc)</td>
              <td style="padding: 5px;">$100 Allowance</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Medical (Authorization Required)</td>
              <td style="padding: 5px;">$250 Allowance</td>
              <td style="padding: 5px;">$250 Allowance</td>
            </tr>

            <!-- Lens Options -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lens Options</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Advanced Lens Designs</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Other Materials (Poly, High Index, Trivex)</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Solid Tints</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Gradient Tints</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Premium AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Transition</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Polarized</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">All Other Options Not Listed</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
          </table><br>`;
      case 19710:
        return `
          <table style="width: 100%; font-size: 11px; border-collapse: collapse; border: 1px solid #ccc;">
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td colspan="3" style="padding: 5px; text-align: center;">Summary of Benefits</td>
            </tr>
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td style="padding: 5px;"></td>
              <td style="padding: 5px;">In Network</td>
              <td style="padding: 5px;">Out of Network</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Exams: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Routine Eye Exam</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">$65 Reimbursement</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Contact Lens Fitting</td>
              <td style="padding: 5px;">No Coverage</td>
              <td style="padding: 5px;">-</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Frames: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Frames</td>
              <td style="padding: 5px;">$80 Allowance<br>20% Off Overage</td>
              <td style="padding: 5px;">$65 Reimbursement</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lenses: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Single Vision (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">$59 Reimbursement</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Bifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">$79 Reimbursement</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Trifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">$99 Reimbursement</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard Progressive (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">$99 Reimbursement</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Contact Lenses: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Elective (In Lieu of Glasses; Services incl)</td>
              <td style="padding: 5px;">$80 Allowance</td>
              <td style="padding: 5px;">$105 Reimbursement (including exam)</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Medical (Authorization Required)</td>
              <td style="padding: 5px;">$250 Allowance</td>
              <td style="padding: 5px;">$210 Reimbursement (including exam)</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lens Options</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Advanced Lens Designs</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Other Materials (Poly, High Index, Trivex)</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Solid Tints</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Gradient Tints</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Premium AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Transition</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Polarized</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">All Other Options Not Listed</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
          </table><br>`;
      case 7800:
        return `
          <table style="width: 100%; font-size: 11px; border-collapse: collapse; border: 1px solid #ccc;">
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td colspan="3" style="padding: 5px; text-align: center;">Summary of Benefits</td>
            </tr>
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td style="padding: 5px;"></td><td style="padding: 5px;">In Network</td><td style="padding: 5px;">Out of Network</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Exams: Every 24 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Routine Eye Exam</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">$45 Allowance</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Contact Lens Fitting</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Frames: Every 24 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Frames</td>
              <td style="padding: 5px;">
                Standard: Fully Covered<br>
                Designer: $24 Allowance,<br>20% off Overage
              </td>
              <td style="padding: 5px;">$45 Allowance</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lenses: Every 24 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Single Vision (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">$38 Allowance</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Bifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">$50 Allowance</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Trifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">$59 Allowance</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard Progressive (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">$59 Allowance</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Contact Lenses: Every 24 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Elective (In Lieu of Glasses, Services incl)</td>
              <td style="padding: 5px;">$50 Allowance</td>
              <td style="padding: 5px;">$61 Allowance</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Medical (Authorization Required)</td>
              <td style="padding: 5px;">$250 Allowance</td>
              <td style="padding: 5px;">$169 Allowance</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lens Options</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Advanced Lens Designs</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Other Materials (Poly, High Index, Trivex)</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Solid Tints</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">Fully Covered</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Gradient Tints</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Premium AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Transition</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Polarized</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">All Other Options Not Listed</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
          </table><br>`;
      case 19840:
        return `
          <table style="width: 100%; font-size: 11px; border-collapse: collapse; border: 1px solid #ccc;">
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td colspan="3" style="padding: 5px; text-align: center;">Summary of Benefits</td>
            </tr>
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td style="padding: 5px;"></td>
              <td style="padding: 5px;">In Network</td>
              <td style="padding: 5px;">Out of Network</td>
            </tr>

            <!-- Exams -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="padding: 5px;">Exams: Every 12 months</td>
            </tr>
            <tr>
              <td style="padding: 5px;">Routine Eye Exam</td>
              <td style="padding: 5px;">Fully Covered<br>$10 Copay</td>
              <td style="padding: 5px;">$39 Allowance</td>
            </tr>
            <tr>
              <td style="padding: 5px;">Contact Lens Fitting</td>
              <td style="padding: 5px;">No Coverage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Frames -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="padding: 5px;">Frames: Every 24 months</td>
            </tr>
            <tr>
              <td style="padding: 5px;">Frames</td>
              <td style="padding: 5px;">
                $130 Allowance<br>
                20% Off Overage<br>
                $25 Material Copay
              </td>
              <td style="padding: 5px;">
                $46 Allowance<br>
                $25 Material Copay
              </td>
            </tr>

            <!-- Lenses -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="padding: 5px;">Lenses: Every 12 months</td>
            </tr>
            <tr>
              <td style="padding: 5px;">Single Vision (Plastic)</td>
              <td style="padding: 5px;">$25 Material Copay</td>
              <td style="padding: 5px;">$25 Allowance<br>$25 Material Copay</td>
            </tr>
            <tr>
              <td style="padding: 5px;">Bifocal (Plastic)</td>
              <td style="padding: 5px;">$25 Material Copay</td>
              <td style="padding: 5px;">$40 Allowance<br>$25 Material Copay</td>
            </tr>
            <tr>
              <td style="padding: 5px;">Trifocal (Plastic)</td>
              <td style="padding: 5px;">$25 Material Copay</td>
              <td style="padding: 5px;">$60 Allowance<br>$25 Material Copay</td>
            </tr>
            <tr>
              <td style="padding: 5px;">Standard Progressive (Plastic)</td>
              <td style="padding: 5px;">$25 Material Copay</td>
              <td style="padding: 5px;">$60 Allowance<br>$25 Material Copay</td>
            </tr>

            <!-- Contact Lenses -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="padding: 5px;">Contact Lenses: Every 24 months</td>
            </tr>
            <tr>
              <td style="padding: 5px;">Elective (In Lieu of Glasses, Services incl)</td>
              <td style="padding: 5px;">
                $130 Allowance<br>
                $25 Material Copay
              </td>
              <td style="padding: 5px;">
                $100 Allowance<br>
                $25 Material Copay
              </td>
            </tr>
            <tr>
              <td style="padding: 5px;">Medical (Authorization Required)</td>
              <td style="padding: 5px;">$250 Allowance</td>
              <td style="padding: 5px;">$200 Allowance</td>
            </tr>

            <!-- Lens Options -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="padding: 5px;">Lens Options</td>
            </tr>
            <tr>
              <td style="padding: 5px;">Advanced Lens Designs</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="padding: 5px;">Other Materials (Poly, High Index, Trivex)</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="padding: 5px;">Solid Tints</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">Fully Covered</td>
            </tr>
            <tr>
              <td style="padding: 5px;">Gradient Tints</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="padding: 5px;">Standard AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="padding: 5px;">Premium AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="padding: 5px;">Transition</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="padding: 5px;">Polarized</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="padding: 5px;">All Other Options Not Listed</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
          </table><br>`;
      case 4170:
        return `
          <table style="width: 100%; font-size: 11px; border-collapse: collapse; border: 1px solid #ccc;">
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td colspan="3" style="padding: 5px; text-align: center;">Summary of Benefits</td>
            </tr>
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td style="padding: 5px;"></td>
              <td style="padding: 5px;">In Network</td>
              <td style="padding: 5px;">Out of Network</td>
            </tr>

            <!-- Exams -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Exams: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Routine Eye Exam</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Contact Lens Fitting</td>
              <td style="padding: 5px;">No Coverage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Frames -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Frames: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Frames</td>
              <td style="padding: 5px;">$50 Allowance<br>20% Off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Lenses -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lenses: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Single Vision (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Bifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Trifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard Progressive (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Contact Lenses -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Contact Lenses: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Elective (In Lieu of Glasses; Services inc)</td>
              <td style="padding: 5px;">$100 Allowance</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Medical (Authorization Required)</td>
              <td style="padding: 5px;">$250 Allowance</td>
              <td style="padding: 5px;">$250 Allowance</td>
            </tr>

            <!-- Lens Options -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lens Options</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Advanced Lens Designs</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Other Materials (Poly, High Index, Trivex)</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Solid Tints</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Gradient Tints</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Premium AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Transition</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Polarized</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">All Other Options Not Listed</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
          </table><br>`;
      case 7420:
        return `
          <table style="width: 100%; font-size: 11px; border-collapse: collapse; border: 1px solid #ccc;">
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td colspan="3" style="padding: 5px; text-align: center;">Summary of Benefits</td>
            </tr>
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td style="padding: 5px;"></td>
              <td style="padding: 5px;">In Network</td>
              <td style="padding: 5px;">Out of Network</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Exams: Every 24 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Routine Eye Exam</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Contact Lens Fitting</td>
              <td style="padding: 5px;">No Coverage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Frames: Every 24 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Frames</td>
              <td style="padding: 5px;">$50 Allowance<br>20% Off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lenses: Every 24 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Single Vision (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Bifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Trifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard Progressive (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Contact Lenses: Every 24 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Elective (In Lieu of Glasses; Services inc)</td>
              <td style="padding: 5px;">$100 Allowance</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Medical (Authorization Required)</td>
              <td style="padding: 5px;">$250 Allowance</td>
              <td style="padding: 5px;">$250 Allowance</td>
            </tr>

            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lens Options</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Advanced Lens Designs</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Other Materials (Poly, High Index, Trivex)</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Solid Tints</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Gradient Tints</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Premium AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Transition</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Polarized</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">All Other Options Not Listed</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
          </table><br>`;
      case 6620:
        return `
          <table style="width: 100%; font-size: 11px; border-collapse: collapse; border: 1px solid #ccc;">
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td colspan="3" style="padding: 5px; text-align: center;">Summary of Benefits</td>
            </tr>
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td style="padding: 5px;"></td>
              <td style="padding: 5px;">In Network</td>
              <td style="padding: 5px;">Out of Network</td>
            </tr>

            <!-- Exams -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Exams: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Routine Eye Exam</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Contact Lens Fitting</td>
              <td style="padding: 5px;">No Coverage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Frames -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Frames: Every 24 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Frames</td>
              <td style="padding: 5px;">
                $50 Allowance<br>
                20% Off Overage
              </td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Lenses -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lenses: Every 24 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Single Vision (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Bifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Trifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard Progressive (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Contact Lenses -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Contact Lenses: Every 24 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Elective (In Lieu of Frames, Services inc)</td>
              <td style="padding: 5px;">$100 Allowance</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Medical (Authorization Required)</td>
              <td style="padding: 5px;">$250 Allowance</td>
              <td style="padding: 5px;">$250 Allowance</td>
            </tr>

            <!-- Lens Options -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lens Options</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Advanced Lens Designs</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Other Materials (Poly, High Index, Trivex)</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Solid Tints</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Gradient Tints</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Premium AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Transition</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Polarized</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">All Other Options Not Listed</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
          </table><br>`;
      case 6075:
        return `
          <table style="width: 100%; font-size: 11px; border-collapse: collapse; border: 1px solid #ccc;">
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td colspan="3" style="padding: 5px; text-align: center;">Summary of Benefits</td>
            </tr>
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td style="padding: 5px;"></td><td style="padding: 5px;">In Network</td><td style="padding: 5px;">Out of Network</td>
            </tr>

            <!-- Exams -->
            <tr style="font-weight: bold; background-color: rgb(217, 217, 217);">
              <td style="text-align: left; padding: 5px;">Exams: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Routine Eye Exam</td><td style="padding: 5px;">Fully Covered</td><td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Contact Lens Fitting</td><td style="padding: 5px;">No Coverage</td><td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Frames -->
            <tr style="font-weight: bold; background-color: rgb(217, 217, 217);">
              <td style="text-align: left; padding: 5px;">Frames: Every 24 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Frames</td>
              <td style="padding: 5px;">$80 Allowance<br>20% Off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Lenses -->
            <tr style="font-weight: bold; background-color: rgb(217, 217, 217);">
              <td style="text-align: left; padding: 5px;">Lenses: Every 24 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Single Vision (Plastic)</td><td style="padding: 5px;">Fully Covered</td><td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Bifocal (Plastic)</td><td style="padding: 5px;">Fully Covered</td><td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Trifocal (Plastic)</td><td style="padding: 5px;">Fully Covered</td><td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard Progressive (Plastic)</td><td style="padding: 5px;">Fully Covered</td><td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Contact Lenses -->
            <tr style="font-weight: bold; background-color: rgb(217, 217, 217);">
              <td style="text-align: left; padding: 5px;">Contact Lenses: Every 24 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Elective (In Lieu of Glasses, Services inc)</td>
              <td style="padding: 5px;">$100 Allowance</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Medical (Authorization Required)</td>
              <td style="padding: 5px;">$250 Allowance</td>
              <td style="padding: 5px;">$250 Allowance</td>
            </tr>

            <!-- Lens Options -->
            <tr style="font-weight: bold; background-color: rgb(217, 217, 217);">
              <td style="text-align: left; padding: 5px;">Lens Options</td>
            </tr>
            <tr><td style="text-align: left; padding: 5px;">Advanced Lens Designs</td><td style="padding: 5px;">20% off Overage</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Other Materials (Poly, High Index, Trivex)</td><td style="padding: 5px;">20% off Overage</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Solid Tints</td><td style="padding: 5px;">Fully Covered</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Gradient Tints</td><td style="padding: 5px;">20% off Overage</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Standard AR Coating</td><td style="padding: 5px;">20% off Overage</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Premium AR Coating</td><td style="padding: 5px;">20% off Overage</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Transition</td><td style="padding: 5px;">20% off Overage</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">Polarized</td><td style="padding: 5px;">20% off Overage</td><td style="padding: 5px;">No Coverage</td></tr>
            <tr><td style="text-align: left; padding: 5px;">All Other Options Not Listed</td><td style="padding: 5px;">20% off Overage</td><td style="padding: 5px;">No Coverage</td></tr>
          </table><br>`;
      case 5755:
        return `
          <table style="width: 100%; font-size: 11px; border-collapse: collapse; border: 1px solid #ccc;">
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td colspan="3" style="padding: 5px; text-align: center;">Summary of Benefits</td>
            </tr>
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td style="padding: 5px;"></td>
              <td style="padding: 5px;">In Network</td>
              <td style="padding: 5px;">Out of Network</td>
            </tr>

            <!-- Exams -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Exams: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Routine Eye Exam</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Contact Lens Fitting</td>
              <td style="padding: 5px;">No Coverage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Frames -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Frames: Every 24 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Frames</td>
              <td style="padding: 5px;">$79 Allowance<br>20% Off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Lenses -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lenses: Every 24 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Single Vision (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Bifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Trifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard Progressive (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Contact Lenses -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Contact Lenses: Every 24 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Elective (In Lieu of Glasses, Services inc)</td>
              <td style="padding: 5px;">$100 Allowance</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Medical (Authorization Required)</td>
              <td style="padding: 5px;">$250 Allowance</td>
              <td style="padding: 5px;">$250 Allowance</td>
            </tr>

            <!-- Lens Options -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lens Options</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Advanced Lens Designs</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Other Materials (Poly, High Index, Trivex)</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Solid Tints</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Gradient Tints</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Premium AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Transition</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Polarized</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">All Other Options Not Listed</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
          </table><br>`;
      case 5700:
        return `
          <table style="width: 100%; font-size: 11px; border-collapse: collapse; border: 1px solid #ccc;">
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td colspan="3" style="padding: 5px; text-align: center;">Summary of Benefits</td>
            </tr>
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td style="padding: 5px;"></td>
              <td style="padding: 5px;">In Network</td>
              <td style="padding: 5px;">Out of Network</td>
            </tr>

            <!-- Exams -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Exams: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Routine Eye Exam</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Contact Lens Fitting</td>
              <td style="padding: 5px;">No Coverage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Frames -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Frames: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Frames</td>
              <td style="padding: 5px;">$24 Allowance<br>20% Off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Lenses -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lenses: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Single Vision (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Bifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Trifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard Progressive (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Contact Lenses -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Contact Lenses: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Elective (In Lieu of Glasses, Services inc)</td>
              <td style="padding: 5px;">$90 Allowance</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Medical (Authorization Required)</td>
              <td style="padding: 5px;">$250 Allowance</td>
              <td style="padding: 5px;">$250 Allowance</td>
            </tr>

            <!-- Lens Options -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lens Options</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Advanced Lens Designs</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Other Materials (Poly, High Index, Trivex)</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Solid Tints</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Gradient Tints</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Premium AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Transition</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Polarized</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">All Other Options Not Listed</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
          </table><br>`;
      case 19630:
        return `
          <table style="width: 100%; font-size: 11px; border-collapse: collapse; border: 1px solid #ccc;">
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td colspan="3" style="padding: 5px; text-align: center;">Summary of Benefits</td>
            </tr>
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td style="padding: 5px;"></td>
              <td style="padding: 5px;">In Network</td>
              <td style="padding: 5px;">Out of Network</td>
            </tr>

            <!-- Exams -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="padding: 5px;">Exams: Every 12 months</td>
            </tr>
            <tr>
              <td style="padding: 5px;">Routine Eye Exam</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="padding: 5px;">Contact Lens Fitting</td>
              <td style="padding: 5px;">No Coverage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Frames -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="padding: 5px;">Frames: Every 12 months</td>
            </tr>
            <tr>
              <td style="padding: 5px;">Frames</td>
              <td style="padding: 5px;">
                $120 Allowance<br>
                20% Off Overage<br>
                $25 Material Copay
              </td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Lenses -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="padding: 5px;">Lenses: Every 12 months</td>
            </tr>
            <tr>
              <td style="padding: 5px;">Single Vision (Plastic)</td>
              <td style="padding: 5px;">$25 Material Copay</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="padding: 5px;">Bifocal (Plastic)</td>
              <td style="padding: 5px;">$25 Material Copay</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="padding: 5px;">Trifocal (Plastic)</td>
              <td style="padding: 5px;">$25 Material Copay</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="padding: 5px;">Standard Progressive (Plastic)</td>
              <td style="padding: 5px;">$25 Material Copay</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Contact Lenses -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="padding: 5px;">Contact Lenses: Every 24 months</td>
            </tr>
            <tr>
              <td style="padding: 5px;">Elective (In Lieu of Glasses; Services inc)</td>
              <td style="padding: 5px;">
                $120 Allowance<br>
                $25 Material Copay
              </td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="padding: 5px;">Medical (Authorization Required)</td>
              <td style="padding: 5px;">$250 Allowance</td>
              <td style="padding: 5px;">$250 Allowance</td>
            </tr>

            <!-- Lens Options -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="padding: 5px;">Lens Options</td>
            </tr>
            <tr>
              <td style="padding: 5px;">Advanced Lens Designs</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="padding: 5px;">Other Materials (Poly, High Index, Trivex)</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="padding: 5px;">Solid Tints</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="padding: 5px;">Gradient Tints</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="padding: 5px;">Standard AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="padding: 5px;">Premium AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="padding: 5px;">Transition</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="padding: 5px;">Polarized</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="padding: 5px;">All Other Options Not Listed</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
          </table><br>`;
      case 6355:
        return `
          <table style="width: 100%; font-size: 11px; border-collapse: collapse; border: 1px solid #ccc;">
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td colspan="3" style="padding: 5px; text-align: center;">Summary of Benefits</td>
            </tr>
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td style="padding: 5px;"></td>
              <td style="padding: 5px;">In Network</td>
              <td style="padding: 5px;">Out of Network</td>
            </tr>

            <!-- Exams -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Exams: Every 24 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Routine Eye Exam</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Contact Lens Fitting</td>
              <td style="padding: 5px;">No Coverage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Frames -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Frames: Every 24 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Frames</td>
              <td style="padding: 5px;">$50 Allowance<br>20% Off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Lenses -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lenses: Every 24 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Single Vision (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Bifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Trifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard Progressive (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Contact Lenses -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Contact Lenses: Every 24 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Elective (In Lieu of Glasses; Services inc)</td>
              <td style="padding: 5px;">$100 Allowance</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Medical (Authorization Required)</td>
              <td style="padding: 5px;">$250 Allowance</td>
              <td style="padding: 5px;">$250 Allowance</td>
            </tr>

            <!-- Lens Options -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lens Options</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Advanced Lens Designs</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Other Materials (Poly, High Index, Trivex)</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Solid Tints</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Gradient Tints</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Premium AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Transition</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Polarized</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">All Other Options Not Listed</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
          </table><br>`;
      case 5835:
        return `
          <table style="width: 100%; font-size: 11px; border-collapse: collapse; border: 1px solid #ccc;">
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td colspan="3" style="padding: 5px; text-align: center;">Summary of Benefits</td>
            </tr>
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td style="padding: 5px;"></td>
              <td style="padding: 5px;">In Network</td>
              <td style="padding: 5px;">Out of Network</td>
            </tr>

            <!-- Exams -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Exams: Every 24 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Routine Eye Exam</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Contact Lens Fitting</td>
              <td style="padding: 5px;">No Coverage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Frames -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Frames: Every 24 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Frames</td>
              <td style="padding: 5px;">$50 Allowance<br>20% Off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Lenses -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lenses: Every 24 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Single Vision (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Bifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Trifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard Progressive (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Contact Lenses -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Contact Lenses: Every 24 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Elective (In Lieu of Glasses; Services inc)</td>
              <td style="padding: 5px;">$100 Allowance</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Medical (Authorization Required)</td>
              <td style="padding: 5px;">$250 Allowance</td>
              <td style="padding: 5px;">$250 Allowance</td>
            </tr>

            <!-- Lens Options -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lens Options</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Advanced Lens Designs</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Other Materials (Poly, High Index, Trivex)</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Solid Tints</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Gradient Tints</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Premium AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Transition</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Polarized</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">All Other Options Not Listed</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
          </table><br>`;
      case 4080:
        return `
          <table style="width: 100%; font-size: 11px; border-collapse: collapse; border: 1px solid #ccc;">
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td colspan="3" style="padding: 5px; text-align: center;">Summary of Benefits</td>
            </tr>
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td style="padding: 5px;"></td>
              <td style="padding: 5px;">In Network</td>
              <td style="padding: 5px;">Out of Network</td>
            </tr>

            <!-- Exams -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Exams: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Routine Eye Exam</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Contact Lens Fitting</td>
              <td style="padding: 5px;">No Coverage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Frames -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Frames: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Frames</td>
              <td style="padding: 5px;">$50 Allowance<br>20% Off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Lenses -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lenses: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Single Vision (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Bifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Trifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard Progressive (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Contact Lenses -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Contact Lenses: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Elective (In Lieu of Glasses; Services inc)</td>
              <td style="padding: 5px;">$100 Allowance</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Medical (Authorization Required)</td>
              <td style="padding: 5px;">$250 Allowance</td>
              <td style="padding: 5px;">$250 Allowance</td>
            </tr>

            <!-- Lens Options -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lens Options</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Advanced Lens Designs</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Other Materials (Poly, High Index, Trivex)</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Solid Tints</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Gradient Tints</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Premium AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Transition</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Polarized</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">All Other Options Not Listed</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
          </table><br>`;
      case 4700:
        return `
          <table style="width: 100%; font-size: 11px; border-collapse: collapse; border: 1px solid #ccc;">
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td colspan="3" style="padding: 5px; text-align: center;">Summary of Benefits</td>
            </tr>
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td style="padding: 5px;"></td>
              <td style="padding: 5px;">In Network</td>
              <td style="padding: 5px;">Out of Network</td>
            </tr>

            <!-- Exams -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Exams: Every 24 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Routine Eye Exam</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Contact Lens Fitting</td>
              <td style="padding: 5px;">No Coverage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Frames -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Frames: Every 24 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Frames</td>
              <td style="padding: 5px;">$50 Allowance<br>20% Off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Lenses -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lenses: Every 24 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Single Vision (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Bifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Trifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard Progressive (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Contact Lenses -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Contact Lenses: Every 24 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Elective (In Lieu of Glasses; Services inc)</td>
              <td style="padding: 5px;">$100 Allowance</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Medical (Authorization Required)</td>
              <td style="padding: 5px;">$250 Allowance</td>
              <td style="padding: 5px;">$250 Allowance</td>
            </tr>

            <!-- Lens Options -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lens Options</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Advanced Lens Designs</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Other Materials (Poly, High Index, Trivex)</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Solid Tints</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Gradient Tints</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Premium AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Transition</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Polarized</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">All Other Options Not Listed</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
          </table><br>`;
      case 19050:
        return `
          <table style="width: 100%; font-size: 11px; border-collapse: collapse; border: 1px solid #ccc;">
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td colspan="3" style="padding: 5px; text-align: center;">Summary of Benefits</td>
            </tr>
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td style="padding: 5px;"></td>
              <td style="padding: 5px;">In Network</td>
              <td style="padding: 5px;">Out of Network</td>
            </tr>

            <!-- Exams -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Exams: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Routine Eye Exam</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Contact Lens Fitting</td>
              <td style="padding: 5px;">No Coverage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Frames -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Frames: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Frames</td>
              <td style="padding: 5px;">$50 Allowance<br>20% Off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Lenses -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lenses: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Single Vision (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Bifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Trifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard Progressive (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Contact Lenses -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Contact Lenses: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Elective (In Lieu of Glasses; Services inc)</td>
              <td style="padding: 5px;">$100 Allowance</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Medical (Authorization Required)</td>
              <td style="padding: 5px;">$250 Allowance</td>
              <td style="padding: 5px;">$250 Allowance</td>
            </tr>

            <!-- Lens Options -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lens Options</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Advanced Lens Designs</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Other Materials (Poly, High Index, Trivex)</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Solid Tints</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Gradient Tints</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Premium AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Transition</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Polarized</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">All Other Options Not Listed</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
          </table><br>`;
      case 19575:
        return `
          <table style="width: 100%; font-size: 11px; border-collapse: collapse; border: 1px solid #ccc;">
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td colspan="3" style="padding: 5px; text-align: center;">Summary of Benefits</td>
            </tr>
            <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
              <td style="padding: 5px;"></td>
              <td style="padding: 5px;">In Network</td>
              <td style="padding: 5px;">Out of Network</td>
            </tr>

            <!-- Exams -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Exams: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Routine Eye Exam</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Contact Lens Fitting</td>
              <td style="padding: 5px;">No Coverage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Frames -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Frames: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Frames</td>
              <td style="padding: 5px;">$130 Allowance<br>20% Off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Lenses -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lenses: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Single Vision (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Bifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Trifocal (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard Progressive (Plastic)</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>

            <!-- Contact Lenses -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Contact Lenses: Every 12 months</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Elective (In Lieu of Glasses)</td>
              <td style="padding: 5px;">$130 Allowance</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Medical (Authorization Required)</td>
              <td style="padding: 5px;">$250 Allowance</td>
              <td style="padding: 5px;">$250 Allowance</td>
            </tr>

            <!-- Lens Options -->
            <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
              <td colspan="3" style="text-align: left; padding: 5px;">Lens Options</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Advanced Lens Designs</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Other Materials (Poly, High Index, Trivex)</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Solid Tints</td>
              <td style="padding: 5px;">Fully Covered</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Gradient Tints</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Standard AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Premium AR Coating</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Transition</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">Polarized</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 5px;">All Other Options Not Listed</td>
              <td style="padding: 5px;">20% off Overage</td>
              <td style="padding: 5px;">No Coverage</td>
            </tr>
          </table><br>`;
      case 19800:
          return `
            <table style="width: 100%; font-size: 11px; border-collapse: collapse; border: 1px solid #ccc;">
              <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
                <td colspan="3" style="padding: 5px; text-align: center;">Summary of Benefits</td>
              </tr>
              <tr style="background-color: rgb(191, 191, 191); font-weight: bold;">
                <td style="padding: 5px;"></td>
                <td style="padding: 5px;">In Network</td>
                <td style="padding: 5px;">Out of Network</td>
              </tr>

              <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
                <td colspan="3" style="text-align: left; padding: 5px;">Exams: Every 12 months</td>
              </tr>
              <tr>
                <td style="text-align: left; padding: 5px;">Routine Eye Exam</td>
                <td style="padding: 5px;">Fully Covered</td>
                <td style="padding: 5px;">No Coverage</td>
              </tr>
              <tr>
                <td style="text-align: left; padding: 5px;">Contact Lens Fitting</td>
                <td style="padding: 5px;">No Coverage</td>
                <td style="padding: 5px;">No Coverage</td>
              </tr>

              <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
                <td colspan="3" style="text-align: left; padding: 5px;">Frames: Every 12 months</td>
              </tr>
              <tr>
                <td style="text-align: left; padding: 5px;">Frames</td>
                <td style="padding: 5px;">$75 Allowance<br>20% Off Overage</td>
                <td style="padding: 5px;">No Coverage</td>
              </tr>

              <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
                <td colspan="3" style="text-align: left; padding: 5px;">Lenses: Every 12 months</td>
              </tr>
              <tr>
                <td style="text-align: left; padding: 5px;">Single Vision (Plastic)</td>
                <td style="padding: 5px;">Fully Covered</td>
                <td style="padding: 5px;">No Coverage</td>
              </tr>
              <tr>
                <td style="text-align: left; padding: 5px;">Bifocal (Plastic)</td>
                <td style="padding: 5px;">Fully Covered</td>
                <td style="padding: 5px;">No Coverage</td>
              </tr>
              <tr>
                <td style="text-align: left; padding: 5px;">Trifocal (Plastic)</td>
                <td style="padding: 5px;">Fully Covered</td>
                <td style="padding: 5px;">No Coverage</td>
              </tr>
              <tr>
                <td style="text-align: left; padding: 5px;">Standard Progressive (Plastic)</td>
                <td style="padding: 5px;">Fully Covered</td>
                <td style="padding: 5px;">No Coverage</td>
              </tr>

              <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
                <td colspan="3" style="text-align: left; padding: 5px;">Contact Lenses: Every 12 months</td>
              </tr>
              <tr>
                <td style="text-align: left; padding: 5px;">Elective (In Lieu of Glasses)</td>
                <td style="padding: 5px;">$100 Allowance</td>
                <td style="padding: 5px;">No Coverage</td>
              </tr>
              <tr>
                <td style="text-align: left; padding: 5px;">Medical (Authorization Required)</td>
                <td style="padding: 5px;">$250 Allowance</td>
                <td style="padding: 5px;">$250 Allowance</td>
              </tr>

              <tr style="font-weight: bold; background-color: rgb(238, 238, 238);">
                <td colspan="3" style="text-align: left; padding: 5px;">Lens Options</td>
              </tr>
              <tr>
                <td style="text-align: left; padding: 5px;">Advanced Lens Designs</td>
                <td style="padding: 5px;">20% off Overage</td>
                <td style="padding: 5px;">No Coverage</td>
              </tr>
              <tr>
                <td style="text-align: left; padding: 5px;">Other Materials (Poly, High Index, Trivex)</td>
                <td style="padding: 5px;">20% off Overage</td>
                <td style="padding: 5px;">No Coverage</td>
              </tr>
              <tr>
                <td style="text-align: left; padding: 5px;">Solid Tints</td>
                <td style="padding: 5px;">Fully Covered</td>
                <td style="padding: 5px;">No Coverage</td>
              </tr>
              <tr>
                <td style="text-align: left; padding: 5px;">Gradient Tints</td>
                <td style="padding: 5px;">20% off Overage</td>
                <td style="padding: 5px;">No Coverage</td>
              </tr>
              <tr>
                <td style="text-align: left; padding: 5px;">Standard AR Coating</td>
                <td style="padding: 5px;">20% off Overage</td>
                <td style="padding: 5px;">No Coverage</td>
              </tr>
              <tr>
                <td style="text-align: left; padding: 5px;">Premium AR Coating</td>
                <td style="padding: 5px;">20% off Overage</td>
                <td style="padding: 5px;">No Coverage</td>
              </tr>
              <tr>
                <td style="text-align: left; padding: 5px;">Transition</td>
                <td style="padding: 5px;">20% off Overage</td>
                <td style="padding: 5px;">No Coverage</td>
              </tr>
              <tr>
                <td style="text-align: left; padding: 5px;">Polarized</td>
                <td style="padding: 5px;">20% off Overage</td>
                <td style="padding: 5px;">No Coverage</td>
              </tr>
              <tr>
                <td style="text-align: left; padding: 5px;">All Other Options Not Listed</td>
                <td style="padding: 5px;">20% off Overage</td>
                <td style="padding: 5px;">No Coverage</td>
              </tr>
            </table><br>`;
        }
      
    }
